module.exports = __webpack_public_path__ + "img/backstage-pass.1b3c4c3a.svg";